import { render, staticRenderFns } from "./BlockPackageForm.vue?vue&type=template&id=2d041f08&"
import script from "./BlockPackageForm.vue?vue&type=script&lang=js&"
export * from "./BlockPackageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports